export default __webpack_public_path__ + "static/media/7.e3523b34.jpeg";